export const isoDate = (date: Date): string => {
  date = new Date(+date);
  return new Date(
    date.setTime(date.getTime() - date.getTimezoneOffset() * 60 * 1000),
  )
    .toISOString()
    .slice(0, 10);
};
